export const routers = {
  Home: "/",

  CasinoGame: "/casino/:code",
  GameRoom: "/game-room/:gameId",
  // A provider game's public page; the name part is optional and only for search engines.
  GamePage: "/games/:provider/:gameId/:slug?",
  // Every provider of the site, and one provider's games.
  Providers: "/providers",
  ProviderPage: "/providers/:provider",
  // In-house games are played on their own page rather than in a provider
  // iframe; `detail.route` on the catalog row points here (see
  // apps/main/backend/src/modules/crash/seed).
  Crash: "/casino/crash-original-game",
  Limbo: "/casino/limbo-original-game",
  Plinko: "/casino/plinko-original-game",
  Keno: "/casino/keno-original-game",
  Diamonds: "/casino/diamonds-original-game",
  Coinflip: "/casino/coinflip-original-game",
  Mines: "/casino/mines-original-game",
  Slide: "/casino/slide-original-game",
  FlowerPoker: "/casino/flower-poker-original-game",
  Blackjack: "/casino/blackjack-original-game",
  Wheel: "/casino/wheel-original-game",
  Goal: "/casino/goal-original-game",
  Snakes: "/casino/snakes-original-game",
  Chicken: "/casino/chicken-original-game",
  Roulette: "/casino/roulette-original-game",
  VideoPoker: "/casino/video-poker-original-game",
  Dice: "/casino/dice-original-game",
  Darts: "/casino/darts-original-game",
  Baccarat: "/casino/baccarat-original-game",
  BaccaratTable: "/casino/baccarat-table-original-game",
  Hilo: "/casino/hilo-original-game",
  HiloTable: "/casino/hilo-table-original-game",
  // Multiplayer Hold'em: the lobby, and one table.
  Poker: "/casino/poker-original-game",
  PokerTable: "/casino/poker-original-game/:tableId",
  // Pot-limit Omaha: the same page and tables, its lobby showing only Omaha.
  Omaha: "/casino/omaha-original-game",
  OmahaTable: "/casino/omaha-original-game/:tableId",
  // Multiplayer 13-card Points Rummy: the lobby, and one table.
  Rummy: "/casino/rummy-original-game",
  RummyTable: "/casino/rummy-original-game/:tableId",
  // Multiplayer Truco Argentino: the lobby, and one table.
  Truco: "/casino/truco-original-game",
  TrucoTable: "/casino/truco-original-game/:tableId",
  // Multiplayer Chinchón: the lobby, and one table.
  Chinchon: "/casino/chinchon-original-game",
  ChinchonTable: "/casino/chinchon-original-game/:tableId",
  // Multiplayer Teen Patti: the lobby, and one table.
  TeenPatti: "/casino/teen-patti-original-game",
  TeenPattiTable: "/casino/teen-patti-original-game/:tableId",
  RockPaperScissors: "/casino/rock-paper-scissors-original-game",
  RussianRoulette: "/casino/russian-roulette-original-game",

  SportsHome: "/sports/home",
  SportsInPlay: "/sports/in-play",
  SportsNext24: "/sports/next24",
  SportsUpcoming: "/sports/upcoming",
  SportsLobby: "/sports",
  SportsFavorites: "/sports/favourites",
  SportsPromotions: "/sports/promotions",
  SportsSearch: "/sports/search",
  SportRegion: "/sports/:sportSlug/region/:regionSlug",
  SportLeague: "/sports/:sportSlug/region/:regionSlug/:leagueSlug",

  Sports: "/sports/:sportSlug/:eventStatus",
  SportEvent: "/sports/:sportSlug/:regionSlug/:leagueSlug/:eventId/:eventStatus",

  MyBetsCasino: "/casino/my-bets",
  MyBetsSport: "/sports/my-bets",
  Recent: "/recent",
  Favorites: "/favorites",
  Search: "/search",
  Settings: "/settings",
  SettingsAccount: "/settings/account",
  SettingsSecurity: "/settings/security",
  SettingsVerify: "/settings/verify",
  SettingsResponsibleGambling: "/settings/responsible-gambling",
  Notifications: "/notifications",
  Transactions: "/transactions",

  Promotion: "/promotions",
  Referral: "/referral",
  BetShare: "/share/:code",
  VipClubs: "/vip-clubs",
  Tournament: "/tournaments",
  TournamentDetail: "/tournaments/:id",
  WagerRace: "/wager-race",
  Challenges: "/challenges",
  SlotBattles: "/slot-battles",
  SlotBattle: "/slot-battles/:id",
  Raffles: "/raffles",
  Rewards: "/rewards",
  HelpCenter: "/help-center",
  HelpCenterCategory: "/help-center/:category",
  HelpCenterArticle: "/help-center/article/:slug",
  Shop: "/shop",

  PrivacyPolicy: "/privacy-policy",
  TermsService: "/terms-service",
  ResponsibleGambling: "/responsible-gambling",
  AmlKycPolicy: "/aml-kyc-policy",
  BonusTerms: "/bonus-terms",
  CookiePolicy: "/cookie-policy",
  AboutUs: "/about-us",
  Mascot: "/mascot",
  VerifyEmail: "/verify-email",
  ConfirmEmailChange: "/confirm-email-change",
  Unsubscribe: "/unsubscribe",
  ProvablyFair: "/provably-fair",

  Icons: "/icons",
  Loading: "/loading",
  NotFound: "*",
};

// Pages that only render ComingSoon: admin-configured links to them are hidden until they exist.
export const UNBUILT_ROUTES: readonly string[] = [];

export const isUnbuiltRoute = (url?: string): boolean =>
  !!url && UNBUILT_ROUTES.includes(url.split(/[?#]/)[0].replace(/\/+$/, ""));
